export default __webpack_public_path__ + "static/media/date.12199908.svg";